import { useState } from 'react'
import { useSearchParams, useNavigate, Link } from 'react-router-dom'
import apiInstance from '../../utils/axios'
import { useTranslation } from 'react-i18next'; // Import useTranslation
import Swal from 'sweetalert2' 

function CreatePassword() {
    const { t } = useTranslation(); // Initialize useTranslation

    const navigate = useNavigate()
    const [password, setPassword] = useState("")
    const [confirmPassword, setConfirmPassword] = useState("")
    const [currentPassword, setCurrentPassword] = useState("")
    const [isLoading, setIsLoading] =useState(false)
   
    let lang_browser = navigator.language.toLowerCase();
    let lang = localStorage.getItem('language') || (lang_browser.startsWith("en") ? "en" : lang_browser);


    const handlePasswordSubmit = async (e) => {
        e.preventDefault()
        setIsLoading(true)
        if(password !== confirmPassword) {

            Swal.fire({
                toast: true,
                position: 'top',
                icon: 'error',
                title: t("createPassword.passwords_do_not_match"),
                showConfirmButton: false,
                timer: 3000,
                timerProgressBar: true
            })

            setIsLoading(false)
        } else {
            setIsLoading(true)
            const formdata = new FormData()
            formdata.append('password', password)
            formdata.append('current_password', currentPassword)

            try {
                await apiInstance.patch(`user/password-change-profile/`,formdata).then((res) => {
                    Swal.fire({
                        toast: true,
                        position: 'top',
                        icon: 'success',
                        title: t("createPassword.password_changed_successfully", "Password changed successfully."), // Added a default value for safety
                        showConfirmButton: false,
                        timer: 3000,
                        timerProgressBar: true
                    })

                    navigate("/login")
                    setIsLoading(false)
                })
                
            } catch(error) {
                const errorMessage = error.response?.data?.message || t("createPassword.error_changing_password", "Error changing password.");
                Swal.fire({
                    toast: true,
                    position: 'top',
                    icon: 'error',
                    title: errorMessage,
                    showConfirmButton: false,
                    timer: 3000,
                    timerProgressBar: true
                })
                console.log(error.response?.data?.message || error.message)
            } finally {
                 setIsLoading(false)
             }

        }

    }


  return (
    <>
        <div className="form-container-2">
            <div className="form-inner-container-2">
                <h1 className="font">{t("createPassword.change_password")}</h1>
                    <p className="desc-text font pd-b5">{t("createPassword.enter_new_password")}</p>
                    <form onSubmit={handlePasswordSubmit}>
                        {/* Email input */}
                        <div className="form-input-container-1">
                            <label className="form-label-1" htmlFor="current_password">
                            {t("createPassword.current_password")}
                            </label>
                            <input
                                type="password"
                                name="currentPassword"
                                value={currentPassword}
                                className="form-input-1 bgc"
                                onChange={(e) => setCurrentPassword(e.target.value)}

                            />
                        </div>
                        <div className="form-input-container-1">
                            <label className="form-label-1" htmlFor="Full Name">
                            {t("createPassword.password")}
                            </label>
                            <input
                                type="password"
                                name="password"
                                value={password}
                                className="form-input-1 bgc"
                                onChange={(e) => setPassword(e.target.value)}

                            />
                        </div>

                        <div className="form-input-container-1">
                            <label className="form-label-1" htmlFor="Full Name">
                            {t("createPassword.confirm_password")}
                            </label>
                            <input
                                type="password"
                                name="password"
                                value={confirmPassword}
                                className="form-input-1 bgc"
                                onChange={(e) => setConfirmPassword(e.target.value)}

                            />
                        </div>
                        
                        { isLoading === true
                            ?   <button disabled
                                        type='button'
                                        className='form-button-submit-1'                                                                 
                                        //disabled={"isLoading"}
                                    >
                                        <span className="mr-2">Processing...</span>
                                </button>
                            :   <button 
                                        type='submit'
                                        className='form-button-submit-1' 
                                        //disabled={"isLoading"}
                                    >
                                        <span className="mr-2">{t("createPassword.save_password")}</span>
                                        <i className="fas fa-check-circle" />
                                </button>
                        }
                                                                                                      
                        <div className="">
                            <p className='font'>
                            {t("createPassword.want_to_sign_in")} <Link className="sign-up-link" to="/login">Login</Link>
                            </p>
                        </div>
                    </form>
                </div>                                        
        </div>                
    </>
                       
  )
}

export default CreatePassword